import React from "react";

import "./Style.css"
import { useContext } from "react";
import enums from "../../../../services/enums";
import { pixContext } from "../../../../services/Context";
import { Link, useNavigate } from "react-router-dom";
import { CreateKey } from "../../../../services/pix.service";

export default function () {
    const {keyValue, keyType} = useContext(pixContext);
    
    const navigate = useNavigate()
    let displayKeyType = enums.pixTypes.filter((item)=>{
        return item.key == keyType
    })

    return (
        <div className="create-pix-key">
            <div className="container">
                <div className='titulo row'>
                    <div className='col-xl-8'>
                        <p>Confirmação de Chave Pix</p>
                    </div>

                    <div className="col-xl-2">
                        <Link to={"/pagina-pix"}>
                            <button style={{ backgroundColor: "var(--secondary-color)" }}>Nova transferencia</button>
                        </Link>
                    </div>

                    <div className="col-xl-2">
                        <Link to={"/chave-pix"}>
                            <button style={{ backgroundColor: "var(--secondary-color)" }}>Minhas Chaves</button>
                        </Link>
                    </div>
                </div>

                <div className="confirmacao-chave-pix">
                    <div>
                        <h1>Confirma a criação da chave pix?</h1>
                    </div>
                    <div>
                        <p><strong>Tipo da Chave:</strong> {displayKeyType[0].value}</p>
                        <p><strong>Chave:</strong> {keyValue}</p>
                    </div>

                    <div className="">
                            <button style={{ backgroundColor: "var(--secondary-color)" }} className="btn btn-primary col-md-2 me-2" onClick={()=>CreateKey(keyType,keyValue,navigate)}>Confirmar</button>
                            <button className="btn btn-secondary col-md-2" onClick={()=>navigate('/nova-chave-pix')}>Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}